export const StringUtils = {
  equalsIgnoreCase(string1: string, string2: string) {
    return string1?.toLowerCase() === string2?.toLowerCase();
  }
};